import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesNavigationBarComponent} from "./navigation-bar/sales-navigation-bar.component";
import {SalesBuybackSuccessMessageComponent} from "./buyback-success-message/sales-buyback-success-message.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {OnlyAllowedCharactersDirective} from "../../../directives/only-allowed-characters.directive";
import {NoLeadingSpacesDirective} from "../../../directives/no-leading-spaces.directive";
import {NoSpacesDirective} from "../../../directives/no-spaces.directive";
import {UppercaseDirective} from "../../../directives/uppercase.directive";
import {SalesCancelRequestComponent} from "./cancel-request/sales-cancel-request.component";
import {SalesCreditNumberComponent} from "./credit-number/sales-credit-number.component";
import {SalesBreadcrumbsComponent} from "./breadcrumbs/sales-breadcrumbs.component";
import { SalesTopUpLoanSuccessMessageComponent } from './top-up-loan-success-message/sales-top-up-loan-success-message.component';
import {HandMoneyIconComponent} from "../../shared/resources/hand-money-icon/hand-money-icon.component";
import {CircleWalletIconComponent} from "../../shared/resources/circle-wallet-icon/circle-wallet-icon.component";
import {ErrorIconComponent} from "../../shared/resources/error-icon/error-icon.component";
import {BankIconComponent} from "../../shared/resources/bank-icon/bank-icon.component";
import {ContactImgComponent} from "../../shared/resources/contact-img/contact-img.component";
import {AlertIconComponent} from "../../shared/resources/alert-icon/alert-icon.component";
import {WalletIconComponent} from "../../shared/resources/wallet-icon/wallet-icon.component";
import {SalesStatusMessageModalComponentV3} from "../status-message-modal/sales-status-message-modal-v3.component";
import {CirclePlusIconComponent} from "../../shared/resources/circle-plus-icon/circle-plus-icon.component";
import {CircleFullPlusIconComponent} from "../../shared/resources/circle-full-plus-icon/circle-full-plus-icon.component";
import {MoneyWhiteIconComponent} from "../../shared/resources/money-white-icon/money-white-icon.component";
import {EditPriceIconComponent} from "../../shared/resources/edit-price-icon/edit-price-icon.component";
import {ConfirmPriceIconComponent} from "../../shared/resources/confirm-price-icon/confirm-price-icon.component";
import {CrossArrowsIconComponent} from "../../shared/resources/cross-arrows-icon/cross-arrows-icon.component";
import {SuccessLinesIconComponent} from "../../shared/resources/success-lines-icon/success-lines-icon.component";
import {CreditResumeIconComponent} from "../../shared/resources/credit-resume-icon/credit-resume-icon.component";
import {ClientIconComponent} from "../../shared/resources/client-icon/client-icon.component";
import { MoneyIconComponent } from '../../shared/resources/money-icon/money-icon.component';
import { SuccessIconComponent } from '../../shared/resources/success-icon/success-icon.component';
import {CircleMoneyIconComponent} from "../../shared/resources/circle-money-icon/circle-money-icon.component";
import {CircleClientIconComponent} from "../../shared/resources/circle-client-icon/circle-client-icon.component";
import {AlertSimpleIconComponent} from "../../shared/resources/alert-simple-icon/alert-simple-icon.component";
import {
  HandMoneySimpleIconComponent
} from "../../shared/resources/hand-money-simple-icon/hand-money-simple-icon.component";
import {SuccessSimpleIconComponent} from "../../shared/resources/success-simple-icon/success-simple-icon.component";
import {EnrollmentIllustrationComponent} from "../../shared/resources/enrollment-illustration/enrollment-illustration.component";


@NgModule({
  declarations: [
    SalesNavigationBarComponent,
    SalesBuybackSuccessMessageComponent,
    SalesCancelRequestComponent,
    SalesCreditNumberComponent,
    SalesBreadcrumbsComponent,
    SalesTopUpLoanSuccessMessageComponent,
    OnlyAllowedCharactersDirective,
    NoLeadingSpacesDirective,
    ErrorIconComponent,
    BankIconComponent,
    ContactImgComponent,
    SuccessIconComponent,
    AlertIconComponent,
    WalletIconComponent,
    SalesStatusMessageModalComponentV3,
    CirclePlusIconComponent,
    CircleFullPlusIconComponent,
    MoneyWhiteIconComponent,
    MoneyIconComponent,
    EditPriceIconComponent,
    ConfirmPriceIconComponent,
    CrossArrowsIconComponent,
    SuccessLinesIconComponent,
    CreditResumeIconComponent,
    ClientIconComponent,
    HandMoneyIconComponent,
    CircleWalletIconComponent,
    CircleMoneyIconComponent,
    AlertIconComponent,
    CircleClientIconComponent,
    AlertSimpleIconComponent,
    HandMoneySimpleIconComponent,
    SuccessSimpleIconComponent,
    NoLeadingSpacesDirective,
    NoSpacesDirective,
    UppercaseDirective,
    CirclePlusIconComponent,
    CircleFullPlusIconComponent,
    MoneyWhiteIconComponent,
    EditPriceIconComponent,
    ConfirmPriceIconComponent,
    CrossArrowsIconComponent,
    SuccessLinesIconComponent,
    CreditResumeIconComponent,
    ClientIconComponent,
    SuccessIconComponent,
    CircleWalletIconComponent,
    HandMoneyIconComponent,
    CircleMoneyIconComponent,
    AlertIconComponent,
    CircleClientIconComponent,
    AlertSimpleIconComponent,
    HandMoneySimpleIconComponent,
    SuccessSimpleIconComponent,
    EnrollmentIllustrationComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
  ],
  exports: [
    SalesNavigationBarComponent,
    SalesBuybackSuccessMessageComponent,
    SalesCancelRequestComponent,
    SalesCreditNumberComponent,
    SalesBreadcrumbsComponent,
    SalesTopUpLoanSuccessMessageComponent,
    OnlyAllowedCharactersDirective,
    NoLeadingSpacesDirective,
    NoSpacesDirective,
    ErrorIconComponent,
    BankIconComponent,
    ContactImgComponent,
    SuccessIconComponent,
    AlertIconComponent,
    WalletIconComponent,
    SalesStatusMessageModalComponentV3,
    CirclePlusIconComponent,
    CircleFullPlusIconComponent,
    MoneyWhiteIconComponent,
    MoneyIconComponent,
    EditPriceIconComponent,
    ConfirmPriceIconComponent,
    CrossArrowsIconComponent,
    SuccessLinesIconComponent,
    CreditResumeIconComponent,
    ClientIconComponent,
    CircleWalletIconComponent,
    HandMoneyIconComponent,
    CircleMoneyIconComponent,
    AlertIconComponent,
    CircleClientIconComponent,
    AlertSimpleIconComponent,
    HandMoneySimpleIconComponent,
    SuccessSimpleIconComponent,
    NoSpacesDirective,
    UppercaseDirective,
    CirclePlusIconComponent,
    CircleFullPlusIconComponent,
    MoneyWhiteIconComponent,
    EditPriceIconComponent,
    ConfirmPriceIconComponent,
    CrossArrowsIconComponent,
    SuccessLinesIconComponent,
    CreditResumeIconComponent,
    ClientIconComponent,
    SuccessIconComponent,
    CircleWalletIconComponent,
    HandMoneyIconComponent,
    CircleMoneyIconComponent,
    AlertIconComponent,
    CircleClientIconComponent,
    AlertSimpleIconComponent,
    HandMoneySimpleIconComponent,
    SuccessSimpleIconComponent,
    EnrollmentIllustrationComponent
  ]
})
export class GeneralModule { }
